const globalObject = Function('return this')();

export default globalObject;
